import "core-js/modules/es6.string.link";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

var RegularMedia = function RegularMedia() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/RegularMedia.vue');
};

export default {
  components: {
    GlobalRichText: GlobalRichText,
    RegularMedia: RegularMedia
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showBtn: false,
      mobile: true,
      tablet: true
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var small = this.payload.primary.image.small ? formatPrismicImage(this.payload.primary.image.small.url, [this.prismicRatio.small, 'w_375']) : formatPrismicImage(this.payload.primary.image.url, [this.prismicRatio.small, 'w_375']);
      return {
        image: {
          src: small,
          alt: ''
        },
        videoMp4: this.payload.primary.video_mp4 ? formatPrismicImage(this.payload.primary.video_mp4.url, [], '', 'video') : '',
        videoWebm: this.payload.primary.video_webm ? formatPrismicImage(this.payload.primary.video_webm.url, [], '', 'video') : '',
        layout: this.payload.primary.layout || 'center',
        color: this.payload.primary.color || '#3b3b3a',
        autoPlay: this.payload.primary.video_auto_play === 'Yes',
        iconPlayColor: this.payload.primary.video_play_icon_color || '#ffffff',
        title: this.payload.primary.title || [],
        text: this.payload.primary.text || [],
        cta: {
          label: this.payload.primary.call_to_action || '',
          url: this.payload.primary.link.url || ''
        },
        tracking: {
          data: {
            event_category: this.payload.primary.event_category || '',
            event_action: this.payload.primary.event_action || '',
            event_label: this.payload.primary.event_label || ''
          }
        }
      };
    },
    btnClass: function btnClass() {
      return {
        'btn-dark': this.currentPayload.layout === 'right',
        '': this.currentPayload.layout === 'center'
      };
    },
    imageClass: function imageClass() {
      return {
        'col-lg-8 px-0': this.currentPayload.layout === 'right'
      };
    },
    srcset: function srcset() {
      var small = this.payload.primary.image.small ? formatPrismicImage(this.payload.primary.image.small.url, [this.prismicRatio.small, 'w_375']) : formatPrismicImage(this.payload.primary.image.url, [this.prismicRatio.small, 'w_375']);
      var medium = this.payload.primary.image.medium ? formatPrismicImage(this.payload.primary.image.medium.url, [this.prismicRatio.medium, 'w_375', 'dpr_2']) : formatPrismicImage(this.payload.primary.image.url, [this.prismicRatio.medium, 'w_375', 'dpr_2']);
      var large = this.payload.primary.image.large ? formatPrismicImage(this.payload.primary.image.large.url, [this.prismicRatio.large, 'w_1440']) : formatPrismicImage(this.payload.primary.image.url, [this.prismicRatio.large, 'w_1440']);
      var xlarge = this.payload.primary.image.large ? formatPrismicImage(this.payload.primary.image.large.url, [this.prismicRatio.large, 'w_1440', 'dpr_2']) : formatPrismicImage(this.payload.primary.image.url, [this.prismicRatio.large, 'w_1440', 'dpr_2']);
      if (this.mobile && this.payload.primary.layout === 'center') return "".concat(small, " 375w, ").concat(small, " 750w, ").concat(small, " 1440w");
      if (this.tablet && this.payload.primary.layout === 'center') return "".concat(medium, " 375w, ").concat(medium, " 750w, ").concat(medium, " 1440w");
      return "".concat(large, " 375w, ").concat(large, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w");
    },
    prismicRatio: function prismicRatio() {
      var small = this.payload.primary.layout === 'center' ? ['ar_1:1', 'c_crop'] : null;
      var large = ['ar_16:9', 'c_crop'];

      if (this.payload.primary.layout === 'top') {
        large = ['ar_100:41', 'c_crop'];
      }

      if (this.mobile && this.payload.primary.layout === 'center') {
        small = ['ar_4:3', 'c_crop'];
      }

      if (this.payload.primary.layout === 'right') {
        small = ['ar_4:3', 'c_crop'];
        large = ['ar_4:3', 'c_crop'];
      }

      return {
        small: small,
        large: large
      };
    },
    ratio: function ratio() {
      if (this.mobile && this.payload.primary.layout === 'center') {
        return '1:1';
      }

      if (this.payload.primary.layout === 'right') {
        return '4:3';
      }

      if (this.payload.primary.layout === 'top') {
        return '100:41';
      }

      return '16:9';
    }
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
    this.tablet = this.isTablet();
  }
};